export const pmc_user = {
  name: "Shyne Property Manager",
  email: "pmc@shynenetwork.com",
  avatar: "/avatars/shadcn.jpg",
};

export const vendor = {
  name: "Shyne Vendor",
  email: "vendor@shynenetwork.com",
  avatar: "/avatars/shadcn.jpg",
};

export const sub = {
  name: "Shyne Sub",
  email: "vendor@shynenetwork.com",
  avatar: "/avatars/shadcn.jpg",
};

export const individual = {
  name: "Shyne Individual",
  email: "individual@shynenetwork.com",
  avatar: "/avatars/shadcn.jpg",
};


export const APP_URL = import.meta.env.VITE_APP_URL;